// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

// Types
interface DataType {
  address: string
  country_name: string
  email: string
  handphone: string
  province_name: string
  regency_name: string
  subdistrict_name: string
  customer_name:string
}

export function useCustomerDetail(customer_id: string | number): {
  data: DataType | null
  isLoading: boolean
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<DataType | null>(null)
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    api.get(
      "/customer/customerbyid",
      { params: { customer_id } }
    ).then((res: SuccessFetch<{
      payload: DataType
    }>) => {
      setData(res.data.payload)
    }).catch(() => {
      setData(null)
    }).finally(() => {
      setLoading(false)
    })

    return () => {
      setData(null)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}